import React from 'react';

import './FavoriteControl.css';
export class FavoriteControl extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.on = this.props.checked === true;

        this.state = {
            on: this.on
        };
    }

    onClick() {
        if (this.props.disabled !== true) {
            var newValue = !this.on;
            this.setValue(newValue);

            if (this.props.onChange) {
                this.props.onChange(newValue, this);
            }
        }
    }

    setValue(value) {
        this.on = value == true;
        this.setState({
            on: this.on
        });
    }

    getValue() {
        return this.on;
    }

    render() {
        return (
            <div id={this.props.id} key={this.props.id} className={this.props.className}>
                <div className={this.props.disabled ? 'control favorite disabled' : 'control favorite'}>
                    <div className={this.state.on === true ? 'on' : 'off'}>
                        <div className='container' onClick={this.onClick}>
                            <div className={this.state.on === true ? 'glyphicon glyphicon-star' : 'glyphicon glyphicon-star-empty'}></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
